(function () {
  'use strict';

  function init() {
    if (!document.body.classList.contains('template-page-faq')) return;
    var root = document.body;

    buildCatNav(root);
    wireAccordions(root);
    wireSearch(root);
    wireQuickTags(root);
    wireScrollSpy(root);
    // CTA chat-button Podium binding is done inline on the anchor in faq-cta.liquid
    // (using window.PodiumWebChat.open()). No JS wiring needed here.
  }

  function slug(str) {
    return String(str || '').toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');
  }

  function buildCatNav(root) {
    var nav = root.querySelector('.cat-nav');
    if (!nav) return;
    var sections = root.querySelectorAll('.faq-section');
    if (!sections.length) { nav.style.display = 'none'; return; }

    var frag = document.createDocumentFragment();
    sections.forEach(function (sec, i) {
      var anchor = sec.id || slug(sec.dataset.title || 'section-' + (i + 1));
      if (!sec.id) sec.id = anchor;
      var title = sec.dataset.title || sec.querySelector('h2') && sec.querySelector('h2').textContent || ('Section ' + (i + 1));
      var count = sec.querySelectorAll('.faq-item').length;

      var a = document.createElement('a');
      a.href = '#' + anchor;
      a.className = 'cat-nav-link';
      a.dataset.target = anchor;
      a.innerHTML = escapeHtml(title) + ' <span class="count">' + count + '</span>';
      if (i === 0) a.classList.add('active');
      frag.appendChild(a);
    });
    nav.innerHTML = '';
    nav.appendChild(frag);
  }

  function wireAccordions(root) {
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.faq-item .q-btn');
      if (!btn) return;
      var item = btn.closest('.faq-item');
      item.classList.toggle('is-open');
      var expanded = item.classList.contains('is-open');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
    });
  }

  function wireSearch(root) {
    var input = root.querySelector('.search-wrap input');
    if (!input) return;
    var wrap = input.closest('.search-wrap');
    var clear = wrap && wrap.querySelector('.clear-x');

    var debounceTimer = null;
    input.addEventListener('input', function () {
      if (wrap) wrap.classList.toggle('has-value', input.value.length > 0);
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () { filter(root, input.value); }, 150);
    });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { input.value = ''; if (wrap) wrap.classList.remove('has-value'); filter(root, ''); }
    });
    if (clear) {
      clear.addEventListener('click', function () {
        input.value = '';
        wrap.classList.remove('has-value');
        filter(root, '');
        input.focus();
      });
    }
  }

  function filter(root, query) {
    var q = String(query || '').trim().toLowerCase();
    var sections = root.querySelectorAll('.faq-section');
    var totalMatches = 0;

    sections.forEach(function (sec) {
      var items = sec.querySelectorAll('.faq-item');
      var matched = 0;
      items.forEach(function (item) {
        if (!q) {
          item.classList.remove('is-hidden');
          matched++;
          return;
        }
        var text = (item.dataset.search || item.textContent || '').toLowerCase();
        var hit = text.indexOf(q) !== -1;
        item.classList.toggle('is-hidden', !hit);
        if (hit) matched++;
      });
      sec.classList.toggle('is-hidden', matched === 0 && q.length > 0);
      totalMatches += matched;
    });

    document.body.classList.toggle('is-empty', q.length > 0 && totalMatches === 0);

    // expand all matches when actively searching
    if (q.length > 0) {
      root.querySelectorAll('.faq-item:not(.is-hidden)').forEach(function (item) {
        item.classList.add('is-open');
        var btn = item.querySelector('.q-btn');
        if (btn) btn.setAttribute('aria-expanded', 'true');
      });
    }
  }

  function wireQuickTags(root) {
    var input = root.querySelector('.search-wrap input');
    var wrap = input && input.closest('.search-wrap');
    root.querySelectorAll('.quick-tag').forEach(function (tag) {
      tag.addEventListener('click', function () {
        if (!input) return;
        var val = tag.dataset.value || tag.textContent.replace(/^Popular:\s*/i, '').trim();
        input.value = val;
        if (wrap) wrap.classList.add('has-value');
        input.dispatchEvent(new Event('input'));
        input.focus();
        var firstSection = document.querySelector('.faq-section:not(.is-hidden)');
        if (firstSection) {
          var top = firstSection.getBoundingClientRect().top + window.pageYOffset - 80;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      });
    });
  }

  function wireScrollSpy(root) {
    var nav = root.querySelector('.cat-nav');
    if (!nav) return;
    var sections = Array.prototype.slice.call(root.querySelectorAll('.faq-section'));
    if (!sections.length) return;
    var links = root.querySelectorAll('.cat-nav-link');

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var id = entry.target.id;
        links.forEach(function (link) {
          link.classList.toggle('active', link.dataset.target === id);
        });
      });
    }, { rootMargin: '-100px 0px -60% 0px', threshold: 0 });

    sections.forEach(function (sec) { observer.observe(sec); });

    // smooth-scroll for nav clicks (account for sticky header offset)
    nav.addEventListener('click', function (e) {
      var link = e.target.closest('a.cat-nav-link');
      if (!link) return;
      var target = document.getElementById(link.dataset.target);
      if (!target) return;
      e.preventDefault();

      // Clear any active search filter so all sections are visible and reachable.
      var input = document.querySelector('.search-wrap input');
      if (input && input.value) {
        input.value = '';
        var wrap = input.closest('.search-wrap');
        if (wrap) wrap.classList.remove('has-value');
        filter(root, '');
      }

      // Update active state immediately — scroll-spy alone can miss it when the
      // target was display:none a moment ago.
      links.forEach(function (l) { l.classList.toggle('active', l === link); });

      var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
      history.replaceState(null, '', '#' + link.dataset.target);
    });
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
